export default __webpack_public_path__ + "static/media/353.2cd41b28.jpg";